import styled from 'styled-components' 

import Lottie from 'react-lottie';

export const CommomContainer = styled.div.attrs({ 
})`          
    position: relative;
    padding: 30px 0 30px;

    background: var(--black-color);
`; 

export const CommomTitle = styled.div.attrs({  
})`          
    font-size: 30px;
    font-weight: bold;
    line-height: 1em;
    color: var(--white-color);
    margin: 0;
    
    width: 100%;
    max-width: 360px;
`;  
 

export const CommomText = styled.div.attrs({  
})`          
    font-size: 18px;
    line-height: 1.5em;
    color: var(--white-color);
    margin: 15px 0 0 0;

    width: 100%;
    max-width: 360px;
`;  
 


export const CommomImageBanner = styled.img.attrs({  
    src:'/images/capa_site.png'
})`           
    width: 100%;
    max-width: 540px;
    border-radius: 10px;

    @media(max-width: 767px){
        margin-top: 20px;
        margin-botton: 20px;
    }
`;  
 
export const CommomCentred = styled.div.attrs({ 
})`          
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
    ${
        props => props.spaced ? `
            padding-top: 50px;
        ` : ``
    }
`; 

export const BannerCard = styled.div.attrs({ 
})`        
    max-width: 325px;
    margin: 0 auto;
    
`; 

export const BannerCenterContent = styled.div.attrs({ 
})`            
    display: flex;
    flex-direction: column;
    align-items: center;
`; 

export const BannerCenterActions = styled.div.attrs({ 
})`            
    margin: 10px auto 10px;
    flex:1;
`; 



export const BannerLogo = styled.img.attrs({ 
    src:'/icons/logo_joinkids_idiomas.png'
})`           
    // margin: 65px auto 20px;
    // margin: -45px auto 10px;
    margin: 0 0 0 auto 40px;
    width: 100%;
    max-width: 210px;

    `; 





export const BannerTitle = styled.h1.attrs({ 
})`       
    font-size: 18px;
    color: var(--white-color);    

    text-align: center;

`; 
export const BannerSubtitle = styled.div.attrs({ 
})`           
    font-size: 25px;
    line-height: 1.2em;
    color: var(--white-color);    

    text-align: center; 
    margin: 20px auto;
    max-width: 340px;
`; 
export const BannerText = styled.div.attrs({ 
})`           
    font-size: 18px;
    line-height: 1.2em;
    color: var(--white-color);    

    text-align: center;
`; 
export const BannerSubtext = styled.div.attrs({ 
})`           
    font-size: 14px;
    line-height: 1.5em;
    color: var(--white-color);    
    text-align: center;
    margin: 0 auto;
    max-width: 340px;
`; 